<div class="col-12 d-flex justify-content-between mt-1 mb-4 pe-3">
  <div class="col d-flex align-items-center" [class.mt-2]="!titleMenu">
    <h1 class="fs-3 mx-5 my-0">
      @if (titleMenu) {
        <span class="SCD-font p-0 m-0 text-black-primary-color">vb</span>
      }
      <span class="SCD-font p-0 m-0 text-primary-color">{{ titleMenu }}</span>
    </h1>
    <div class="d-flex align-items-center my-0">
      <h2 class="fs-5 fw-bold my-0">
        {{ titlePage }}
      </h2>

      @if(subTitlePage) {
        <h3 class="fs-6 px-2 my-0">-</h3>
        <h3 class="fs-6 my-0">
          {{ subTitlePage }}
        </h3>
      }

      @if(this.headerPageSignalDataService.etapaSubTitlePage$() && !subTitlePage) {
        <h3 class="fs-6 px-2 my-0">-</h3>
        <h3 class="fs-6 my-0">
          {{ this.headerPageSignalDataService.etapaSubTitlePage$() }}
        </h3>
      }
    </div>
  </div>

  <div>
    @if(isShowBack) {
      <button nz-button nzType="default" nzShape="circle"
        class="button-container border-0 bg-transparent shadow-none mx-2" nz-popover
        nzPopoverContent="Voltar Página Anterior" nzPopoverPlacement="bottom" (click)="back()">
        <div class="content">
          <i class="fi fi-rs-undo fs-5"></i>
          <span>Voltar</span>
        </div>
      </button>
    }
  </div>
</div>
